import styled from "styled-components";
import ReactSVG from "react-svg";
import { fromThemeProps } from "../../../helpers/utilities";
import { flex } from "../../../helpers/mixins";
import { PrimaryButton } from "../elements";
import media from "../../../helpers/media";

const StyledHeader = styled.div`
  ${flex({ jc: "space-between", ai: "center" })}
  background: ${fromThemeProps("white")};
  box-shadow: -2px -2px 7px 4px #000;
  height: ${fromThemeProps("headerHeight")};
  position: fixed;
  width: 100%;
  z-index:9999;
  
  transition: .4s linear;
`

StyledHeader.Button = styled(PrimaryButton)`
  display: none;

  ${media.xs`
    display: inline-block;
    position:absolute;
    top: 1.5em;
    right: 6.5em;
  `}
`

StyledHeader.SVG = styled(ReactSVG)`
    width: 150px;
    margin-left: .5em;
    
`

export default StyledHeader;


// WEBPACK FOOTER //
// ./src/styles/styledComponents/blocks/styledHeader.js